import { BLOCKED_ITEM_FORM_CONDITIONS } from '@exam-center/blocked-user-management';
import { BlockedRecordBlockedScope } from '@exam-center/graphql';
import { z } from 'zod';

export const BlockedRecordProctorSchema = z.object({
  blockedCourses: z
    .object({
      type: z.nativeEnum(BlockedRecordBlockedScope, {
        message: 'กรุณากำหนดหลักสูตรที่ระงับสิทธิ์สอบ',
      }),
      courses: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
    })
    .refine(
      (val) => {
        if (val.type === BlockedRecordBlockedScope.PartialScope) {
          return val.courses && val.courses.length > 0;
        }
        return true;
      },
      {
        path: ['courses'],
        message: 'กรุณาเลือกหลักสูตรที่ระงับสิทธิ์สอบ',
      },
    ),
  reason: z
    .string()
    .trim()
    .max(
      BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH,
      `ความยาวต้องไม่เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH} ตัวอักษร`,
    )
    .nullish(),
});

export type BlockedRecordProctorFormInput = z.infer<typeof BlockedRecordProctorSchema>;
